<!--调拨单扫码入仓第二版-可以扫箱子-->
<template>
    <div class="business-content-main" v-loading="loading" element-loading-spinner="none">
        <div class="bread-nav">
            <breadcrumb :canBackHistory="true"></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <div class="search-name">扫码</div>
                <el-input
                    ref="inputdata"
                    class="search-name"
                    v-model="scanData"
                    clearable
                    placeholder="请扫描调拨单号或商品标签"
                    size="small"
                    style="width: 250px"
                    @blur="inputblur()"
                    @change="inputDataChange()"
                ></el-input>
                <el-button v-if="toWarehouseType == 0" size="small" class="search-btn btn-primary" @click="submit()">提交入库</el-button>
                <div class="search-name" v-if="orderCode">调拨单号：{{ orderCode }}</div>
                <div class="search-name" v-if="fromWarehouseName">
                    出库仓库：{{ fromWarehouseName }} <span v-if="fromWarehouseType == 1" style="color: #8492a6">(前置仓)</span>
                </div>
                <div class="search-name" v-if="toWarehouseName">
                    入库仓库：{{ toWarehouseName }} <span v-if="toWarehouseType == 1" style="color: #8492a6">(前置仓)</span>
                </div>
                <div class="search-name" style="color: red">（请先扫调拨单，后扫商品标签。确保焦点在标签输入框内，并检查电脑的输入法是否英文输入）</div>
            </div>
        </div>
        <div>
            <el-row :gutter="20" class="table-ctn">
                <el-col :span="12">
                    <div class="grid-content">
                        <el-table
                            ref="goodsTable"
                            :header-cell-style="{ background: '#F2F6FC' }"
                            border
                            :data="dataList"
                            style="width: 100%"
                            empty-text="请扫描调拨单上的二维码"
                            highlight-current-row
                            @cell-click="showLabelData"
                        >
                            <el-table-column label="汽配编码" show-overflow-tooltip min-width="100px" prop="APCode"></el-table-column>
                            <el-table-column label="汽配名称" show-overflow-tooltip min-width="100px" prop="GoodName"></el-table-column>
                            <el-table-column label="适用车型" show-overflow-tooltip min-width="100px" prop="AutoSerise"></el-table-column>
                            <el-table-column label="库存数" show-overflow-tooltip width="70px" prop="Inventory"></el-table-column>
                            <el-table-column label="调拨数" show-overflow-tooltip width="70px" prop="AllCount"></el-table-column>
                            <el-table-column label="已入库数" show-overflow-tooltip width="80px" prop="WarehousedCount"></el-table-column>
                            <el-table-column label="待入数量" show-overflow-tooltip width="80px">
                                <template slot-scope="scope">
                                    <div
                                        :class="{
                                            'check-class': scope.row.Count > 0
                                        }"
                                    >
                                        {{ scope.row.Count }}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column label="扫码数量" show-overflow-tooltip width="80px">
                                <template slot-scope="scope">
                                    <div
                                        :class="{
                                            'check-class-enough': scope.row.Count - scope.row.ScanCount == 0 && scope.row.ScanCount > 0
                                        }"
                                    >
                                        {{ scope.row.ScanCount }}
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </el-col>
                <el-col :span="12">
                    <div class="grid-content">
                        <div class="labelzone" v-infinite-scroll="bottomLoadHandle">
                            <template v-for="(item, index) in cardList">
                                <el-card :class="'box-card' + (item.IsFilter ? ' card-bg' : '')" :key="index" v-if="index < showLine" @click.native="showGoodsTB(item)">
                                    <div style="padding: 14px">
                                        <span class="goodname">{{ item.GoodName }}</span>
                                        <div class="bottom clearfix">
                                            <span class="apcode">{{ item.APCode }}</span>
                                            <span class="button">
                                                {{ item.PackingSpec + ' ' + item.Unit }}
                                            </span>
                                        </div>
                                        <div class="bottom clearfix">
                                            <time class="time">{{ item.LabelCode }}</time>
                                            <time class="time" v-if="item.BoxId">{{ item.BoxCode }}</time>
                                            <el-button type="text" class="button" icon="el-icon-delete" style="color: red" @click="delItem(item)"></el-button>
                                        </div>
                                    </div>
                                </el-card>
                            </template>
                        </div>
                    </div>
                </el-col>
            </el-row>
            <audio ref="audio" controls hidden></audio>
        </div>
        <!--   入仓     -->
        <el-dialog :close-on-click-modal="false" :show-close="false" title="入仓" :visible.sync="inVisible" width="1000px">
            <div v-if="inVisible">
                <storeInWithLables :EntpTOId="orderId" @closeDialog="closeInDialog"></storeInWithLables>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import storeInWithLables from '@/components/business/goods/transWarehouseInWithLables';
export default {
    name: 'OrderScan',
    components: {
        breadcrumb,
        storeInWithLables
    },
    data() {
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            stype: 0,
            loading: false,
            userMsg: userMsg,
            fromWarehouseName: '',
            toWarehouseName: '',
            toWarehouseId: '',
            fromWarehouseType: 0,
            toWarehouseType: 0,
            oid: '',
            orderId: '',
            dataList: [],
            scanData: '',
            labels: [],
            cardList: [],
            orderCode: '',
            firstScanOrder: true,
            currectAudio: '/download/currect.mp3',
            errorAudio: '/download/error.mp3',
            allOutAudio: '/download/allout.mp3',
            wrongXSAudio: '/download/wrongxs.mp3',
            repetLabel: '/download/repetlabel.mp3',
            enoughAudio: '/download/enough.mp3',
            delAudio: '/download/del.mp3',
            cancelAudio: '/download/cancel.mp3',
            inVisible: false,
            inWGoodsList: [],
            showLine: 25,
            rowSelectId: ''
        };
    },
    mounted() {
        this.stype = this.$route.query.stype;
        if (this.stype == 1) {
            this.oid = this.$route.query.TOId;
            this.getOrderDetail('', this.oid);
        }
    },
    methods: {
        getOrderDetail(orderCode, orderId) {
            let that = this;
            that.$util
                .axiosGet({
                    url: '/api/EntpTransferOrder/GetEntpNewTransInOrderGoods',
                    data: {
                        TOId: orderId,
                        TOCode: orderCode
                    }
                })
                .then(res => {
                    let data = res.data;
                    if (data.ToWarehouseType == 1) {
                        that.firstScanOrder = true;
                        that.aplayAudio(that.errorAudio);
                        that.$util.warningMsg('提醒：调拨单入仓仓库是前置仓哟');
                        that.dataList = [];
                        that.oid = '';
                        that.orderId = '';
                        return;
                    }
                    if (data.State < 3) {
                        that.firstScanOrder = true;
                        that.aplayAudio(that.errorAudio);
                        that.$util.warningMsg('提醒：调拨单未达到入库要求');
                        that.dataList = [];
                        that.oid = '';
                        that.orderId = '';
                        return;
                    }
                    if (data.State == 4) {
                        that.firstScanOrder = true;
                        that.aplayAudio(that.errorAudio);
                        that.$util.warningMsg('提醒：该调拨单已入库完成');
                        that.oid = '';
                        that.orderId = '';
                    } else {
                        that.aplayAudio(that.currectAudio);
                    }
                    that.dataList = [];
                    that.orderId = data.TOId;
                    that.orderCode = data.TOCode;
                    that.fromWarehouseType = data.FromWarehouseType;
                    that.toWarehouseType = data.ToWarehouseType;
                    that.fromWarehouseName = data.FromWarehouseName;
                    that.toWarehouseName = data.ToWarehouseName;
                    that.toWarehouseId = data.ToWarehouseId;
                    let DetailList = data.DetailList;
                    for (let i = 0; i < DetailList.length; i++) {
                        that.dataList.push({
                            GoodsId: DetailList[i].EntpTempGoodsId,
                            APCode: DetailList[i].APCode,
                            GoodName: DetailList[i].GoodName,
                            Unit: DetailList[i].Unit,
                            AutoSerise: DetailList[i].AutoSerise,
                            Inventory: DetailList[i].Inventory,
                            Count: DetailList[i].TCount - DetailList[i].WarehousedCount,
                            AllCount: DetailList[i].TCount,
                            WarehousedCount: DetailList[i].WarehousedCount,
                            ScanCount: 0,
                            SortField: 0,
                            LabelIds: []
                        });
                    }
                });
        },
        // 失去焦点
        inputblur() {
            let that = this;
            if (that.inVisible) return;
            // FireFox 和 IE 失去焦点，blur直接执行focus 不会生效，加个延时
            setTimeout(() => {
                if (that.$refs.inputdata) that.$refs.inputdata.focus();
            }, 100);
        },
        inputDataChange() {
            let that = this;
            if (that.scanData.indexOf('AP-') > -1) {
                if (that.scanData.length == 20) {
                    that.$util
                        .axiosGet({
                            url: '/api/EntpTransferOrder/CheckEntpTransOrderInGoods',
                            data: {
                                TOId: that.orderId,
                                LabelCode: that.scanData
                            }
                        })
                        .then(res => {
                            let data = res.data;
                            if (data) {
                                let datalist = that.dataList;
                                let scount = 0;
                                let needCount = 0;
                                let isFilter = !that.rowSelectId ? false : that.rowSelectId == data.GoodsId;
                                var label = {
                                    APCode: data.APCode,
                                    GoodName: data.GoodName,
                                    PackingSpec: data.PackingSpec,
                                    LabelCode: data.LabelCode,
                                    Unit: data.Unit,
                                    LabelId: data.LabelId,
                                    GoodsId: data.GoodsId,
                                    BoxId: data.BoxId,
                                    BoxCode: data.BoxCode,
                                    IsFilter: isFilter
                                };
                                var isRepet = false;
                                if (that.cardList.length > 0) {
                                    that.cardList.forEach(element => {
                                        if (element.LabelCode == label.LabelCode) {
                                            isRepet = true;
                                            that.$util.warningMsg('重复标签！');
                                            return;
                                        }
                                    });
                                }
                                if (isRepet) {
                                    that.aplayAudio(that.repetLabel);
                                    return;
                                }

                                if (datalist && datalist.length > 0) {
                                    for (let i = 0; i < datalist.length; i++) {
                                        if (datalist[i].GoodsId == label.GoodsId) {
                                            scount = datalist[i].ScanCount;
                                            needCount = datalist[i].Count;

                                            if (scount + label.PackingSpec <= needCount) {
                                                datalist[i].ScanCount += label.PackingSpec;
                                                that.cardList.unshift(label);
                                                that.labels.unshift(data.LabelId);
                                                datalist[i].LabelIds.push(data.LabelId);
                                            } else {
                                                that.aplayAudio(that.enoughAudio);
                                                that.$util.warningMsg('标签的商品总数大于调拨待入的数量！');
                                                return;
                                            }
                                            datalist[i].SortField = datalist[i].Count - datalist[i].ScanCount == 0 && datalist[i].ScanCount > 0 ? 1 : 0;
                                        }
                                    }
                                    datalist.sort(function (a, b) {
                                        return a.SortField - b.SortField;
                                    });
                                    that.aplayAudio(that.currectAudio);
                                }
                            } else {
                                that.aplayAudio(that.errorAudio);
                            }
                        })
                        .catch(() => {
                            that.aplayAudio(that.errorAudio);
                        });
                } else if (that.scanData.length != 0) {
                    that.aplayAudio(that.errorAudio);
                    that.$util.warningMsg('标签码长度不符合规则！请检查输入法是否为英文输入法');
                }
            } else if (that.scanData.length === 36 || that.scanData.indexOf('BX-') > -1) {
                that.$util
                    .axiosGet({
                        url: '/api/EntpTransferOrder/CheckEntpTOrderInBox',
                        data: {
                            TOId: that.orderId,
                            BoxId: that.scanData.length === 36 ? that.scanData : '',
                            BoxCode: that.scanData.indexOf('BX-') > -1 ? that.scanData : ''
                        }
                    })
                    .then(res => {
                        that.scanData = '';
                        let data = res.data;
                        if (!data || data.length == 0) {
                            that.aplayAudio(that.errorAudio);
                            return;
                        }
                        let datalist = that.dataList;
                        //循环整个箱子的标签
                        for (let i = 0; i < data.length; i++) {
                            const l = data[i];
                            if (that.cardList.length > 0) {
                                let isExist = that.cardList.find(x => x.LabelCode == l.LabelCode);
                                if (isExist) {
                                    //跳过重复标签
                                    continue;
                                }
                            }

                            let isFilter = !that.rowSelectId ? false : that.rowSelectId == data.GoodsId;
                            var label = {
                                APCode: l.APCode,
                                GoodName: l.GoodName,
                                PackingSpec: l.PackingSpec,
                                LabelCode: l.LabelCode,
                                Unit: l.Unit,
                                LabelId: l.LabelId,
                                GoodsId: l.GoodsId,
                                BoxId: l.BoxId,
                                BoxCode: l.BoxCode,
                                IsFilter: isFilter
                            };

                            var orderGoods = datalist.find(x => x.GoodsId == l.GoodsId);
                            if (!orderGoods) continue;
                            let scount = orderGoods.ScanCount;
                            let needCount = orderGoods.Count;
                            if (scount + label.PackingSpec <= needCount) {
                                orderGoods.ScanCount += label.PackingSpec;
                                that.cardList.unshift(label);
                                that.labels.unshift(l.LabelId);
                            } else {
                                that.aplayAudio(that.enoughAudio);
                                that.$util.warningMsg(`标签${label.LabelCode}的商品数量超过商品【${orderGoods.APCode}】所需的数量！`);
                                return;
                            }
                            orderGoods.SortField = orderGoods.Count - orderGoods.WarehousedCount - orderGoods.ScanCount == 0 && orderGoods.ScanCount > 0 ? 1 : 0;
                        }
                        datalist.sort(function (a, b) {
                            return a.SortField - b.SortField;
                        });
                        that.dataList = datalist;

                        that.aplayAudio(that.currectAudio);
                    })
                    .catch(() => {
                        that.scanData = '';
                        that.aplayAudio(that.errorAudio);
                    });

                return;
            } else {
                that.orderCode = that.scanData;
                if (that.firstScanOrder) {
                    that.firstScanOrder = false;
                    that.getOrderDetail(that.scanData, '');
                } else {
                    that.$confirm('已经有未提交入库调拨单，是否确定放弃提交？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                        center: false
                    })
                        .then(() => {
                            that.firstScanOrder = true;
                            that.labels = [];
                            that.cardList = [];
                            that.dataList = [];
                            this.getOrderDetail(that.orderCode, '');
                        })
                        .catch(() => {});
                }
            }
            that.scanData = '';
        },
        delItem(item) {
            let that = this;
            if (item) {
                this.cardList.splice(this.cardList.indexOf(item), 1);
                this.labels.splice(this.labels.indexOf(item.LabelId), 1);
                let datalist = that.dataList;
                if (datalist && datalist.length > 0) {
                    for (let i = 0; i < datalist.length; i++) {
                        if (datalist[i].GoodsId == item.GoodsId) {
                            datalist[i].ScanCount -= item.PackingSpec;
                            datalist[i].SortField = datalist[i].Count - datalist[i].ScanCount == 0 && datalist[i].ScanCount > 0 ? 1 : 0;
                            datalist[i].LabelIds.splice(datalist[i].LabelIds.indexOf(item.LabelId), 1);
                            datalist.sort(function (a, b) {
                                return a.SortField - b.SortField;
                            });
                            that.dataList = datalist;
                            return;
                        }
                    }
                }
            }
        },
        submit() {
            let that = this;
            if (that.labels.length == 0) {
                that.$util.warningMsg('无标签信息，请重新扫码');
                return;
            }
            let datalist = that.dataList;
            if (datalist && datalist.length > 0) {
                let scount = 0;
                let needCount = 0;
                for (let i = 0; i < datalist.length; i++) {
                    0;
                    scount = datalist[i].ScanCount;
                    needCount = datalist[i].Count;
                    // if (scount != needCount) {
                    //     that.aplayAudio(that.errorAudio);
                    //     that.$util.warningMsg('所扫的商品标签数不够调拨单入库数！请确认后重新操作');
                    //     return;
                    // }
                }
            } else {
                that.$util.warningMsg('提交的数据异常，请刷新重新操作');
                return;
            }

            that.$confirm('确定提交调拨入库吗？入库后需要主动存放商品哟', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                center: false
            }).then(() => {
                this.loading = true;
                this.$util
                    .axiosPost({
                        url: '/api/EntpTransferOrder/SubmitEntpScanLabelTOInStorage_v2',
                        data: {
                            EntpId: that.userMsg.EntpId,
                            StaffId: that.userMsg.EmployeeId,
                            TOId: that.orderId,
                            LabelIdList: that.labels
                        }
                    })
                    .then(res => {
                        if (res.errcode == 0) {
                            that.$util.successMsg('调拨入库成功');
                            that.$store.commit('updateNeedRefresh', true);
                            that.firstScanOrder = true;
                            that.labels = [];
                            let hasBox = that.cardList.some(c => c.BoxId);
                            that.cardList = [];
                            setTimeout(() => {
                                that.warehouseIn(hasBox);
                            }, 1000);
                        } else {
                            that.$util.successMsg(res.errmsg);
                            that.loading = false;
                        }
                    })
                    .catch(() => {
                        that.loading = false;
                    });
            });
        },
        aplayAudio(audioUrl) {
            this.$refs.audio.src = audioUrl;
            this.$nextTick(res => {
                this.$refs.audio.load();
                this.$refs.audio.play();
            });
        },
        warehouseIn(hasBox) {
            let that = this;
            if (hasBox) {
                that.loading = false;
                return;
            }
            that.inWGoodsList = [];
            that.dataList.forEach(e => {
                that.inWGoodsList.push({
                    EntpTempGoodsId: e.GoodsId,
                    APCode: e.APCode,
                    GoodName: e.GoodName,
                    Count: e.Count,
                    ToWarehouseName: that.toWarehouseName,
                    ToWarehouseId: that.toWarehouseId,
                    ShelfSpaceId: '',
                    ShelfSpacesList: [],
                    LabelIds: e.LabelIds
                });
            });

            that.inVisible = true;
            that.loading = false;
        },
        closeInDialog() {
            this.inWGoodsList = [];
            this.inVisible = false;
            this.getOrderDetail('', this.orderId);
        },
        // 触底加载
        bottomLoadHandle() {
            let listLen = this.cardList.length;
            if (listLen > this.showLine + 25) {
                this.showLine += 25;
            } else {
                this.showLine = listLen;
            }
        },
        showLabelData(item, column) {
            let that = this;
            if (
                (!that.rowSelectId || that.rowSelectId.length == 0 || (that.rowSelectId && that.rowSelectId != item.GoodsId)) &&
                that.cardList &&
                that.cardList.length > 0
            ) {
                that.cardList.forEach(f => {
                    if (f.GoodsId === item.GoodsId) f.IsFilter = true;
                    else f.IsFilter = false;
                });
                that.rowSelectId = item.GoodsId;
            } else {
                that.cardList.forEach(f => {
                    f.IsFilter = false;
                });
                that.rowSelectId = '';
                that.$refs.goodsTable.setCurrentRow();
            }
        },
        showGoodsTB(item) {
            let that = this;
            for (let index = 0; index < that.dataList.length; index++) {
                const element = that.dataList[index];
                if (element.GoodsId == item.GoodsId) {
                    that.$refs.goodsTable.setCurrentRow(element);
                    that.showLabelData(element);
                    return;
                }
            }
        }
    }
};
</script>
<style lang="less" scoped>
.labelzone {
    display: flex;
    justify-content: flex-start;
    align-content: flex-start;
    flex-wrap: wrap;
    padding-left: 20px;
    width: 100%;
    height: 100%;
    margin-bottom: 30px;
    overflow-y: scroll;
    height: calc(100vh - 300px);
}
.labelk {
    display: flex;
    flex-direction: column;
}
.box-card {
    width: 220px;
    margin: 5px;
}

.card-bg {
    background-color: rgb(184, 226, 250);
}

.time {
    font-size: 13px;
    color: #999;
    display: inline-block;
}

.bottom {
    margin-top: 13px;
    line-height: 12px;
}

.button {
    padding: 0;
    float: right;
}

.clearfix:before,
.clearfix:after {
    display: table;
    content: '';
}

.clearfix:after {
    clear: both;
}

.goodname {
    font-size: 18px;
    line-height: 24px;
}
.apcode {
    font-size: 15px;
}
.check-class {
    color: red;
    font-weight: bold;
}
.check-class-enough {
    color: green;
    font-weight: bold;
}
</style>
